<script lang="ts">
	import { page } from '$app/stores';
</script>

<div
	class="bg-fx-black bg-opacity-50 firefox:bg-opacity-50 modal fixed w-full h-full flex justify-end top-0 left-0 backdrop-filter z-20 backdrop-blur-lg sneak-peak"
	style="background-image: 'sneap';"
>
	<div class="flash-light-cover" style="rgba(0, 0, 0, 0), rgba(12, 12, 27, 1));" />
	<div class="flex w-full h-full items-center justify-center z-30">
		<div class="flex flex-col items-center bg-fx-gradient-8 p-10 rounded-3xl squircle-3xl">
			<img src="Logo.webp" alt="Polynomial" class="w-20 h-20 rounded-lg squircle-lg mb-4" />

			<div class="text-fx-grey-200 text-3xl">
				{#if $page.status === 404}
					<h1>You're lost</h1>
					<a href="/">Go Home</a>
				{:else}
					<h1>Whoops. We weren't expecting that</h1>
					<p>Please contact support at discord.</p>
					<h1 class="text-sm">Reason: {$page?.error?.message}</h1>
				{/if}
			</div>

			<div class="my-4 text-fx-grey-300 text-sm text-center">
				{#if $page.error?.errorId}
					<p>Error ID: {$page.error.errorId}</p>
				{/if}
			</div>
			<div class="flex justify-end items-center mt-auto">
				<a href="https://twitter.com/polynomialfi" target="_blank" rel="noreferrer">
					<img src="social/twitter-grey.png" alt="twitter" class="w-5 h-4 mr-8" />
				</a>
				<a href="https://discord.gg/polynomial" target="_blank" rel="noreferrer">
					<img src="social/discord-grey.png" alt="twitter" class="w-5 h-4" />
				</a>
			</div>
		</div>
	</div>
</div>

<style>
	.sneak-peak {
		background-image: url('/sneak_peak.png');
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
	}

	.flash-light-cover {
		width: 100%;
		height: 100%;
		position: absolute;
		pointer-events: none;
	}
</style>
